import { $Qll } from 'graditify-utils';

function getStepSections() {
  const sections = $Qll('.step-section__item');

  return sections;
}

function listenSteps() {
  const steps = getStepSections();
  window.addEventListener('scroll', () => {
    steps.forEach((step, i) => {
      const rect = step.getBoundingClientRect();
      if (
        rect.top >= -100 &&
        rect.bottom <= step.offsetHeight + step.offsetHeight / 2
      ) {
        steps.forEach((step) =>
          step.classList.remove('step-section__item--active')
        );
        if (steps[i - 1]) {
          steps[i - 1].classList.add('step-section__item--active');
        }
        step.classList.add('step-section__item--active');
      }
    });
  });
}

listenSteps();
